@let to = lead.firstTrip?.arrivalAirport?.cityName; @let type = lead.tripType;
@let from = lead.firstTrip?.departureAirport?.cityName;
@let travelers = lead.firstTrip?.passengerCount;
@let departDate = lead.firstTrip?.departureAt ?? ''; @let returnDate = lead.roundTripDepartureAt;

<div class="d-flex flex-column g-6 empty-lead desktop">
  <div class="d-flex flex-column g-4">
    <div class="d-flex g-5 align-items-center">
      @if (showBack) {
        <ds-button
          (click)="goBack()"
          variant="icon"
          icon="chevronLeft"
          label="Back"
          data-id="back"
        />
      }
      <lead-details-title [from]="from" [to]="to" [type]="type" />
    </div>

    <div>
      <lead-details-subtitle
        [departDate]="departDate | date: 'EEE, MMM d'"
        [returnDate]="returnDate | date: 'EEE, MMM d'"
        [travelers]="travelers"
        [showTripRequestLabel]="true"
      />
    </div>
  </div>
  <div class="empty-lead-card d-flex g-5 align-items-center">
    <img [height]="72" [width]="72" alt="magnifier" src="assets/images/magnifying-glass.webp" />
    <div class="d-flex flex-column g-1">
      <h2>{{ cardTitle }}</h2>
      <p>{{ cardSubtitle }}</p>
    </div>
  </div>
  <need-help-card [salesAgent]="lead.salesAgent" class="mb-5" />
</div>

<div class="d-md-none d-flex flex-column empty-lead">
  <div class="d-flex flex-column pb-3 pr-4 pl-4 w-100 empty-lead-header">
    <div class="d-flex g-3 align-items-center">
      @if (showBack) {
        <ds-button
          (click)="goBack()"
          variant="icon"
          icon="chevronLeft"
          label="Back"
          data-id="back"
        />
      }

      <lead-details-title [from]="from" [to]="to" [type]="type" />
    </div>

    <lead-details-subtitle
      [departDate]="departDate | date: 'EEE, MMM d'"
      [returnDate]="returnDate | date: 'EEE, MMM d'"
      [travelers]="travelers"
      [showTripRequestLabel]="true"
    />
  </div>

  <div class="p-4 d-flex flex-column align-items-center g-6">
    <div class="d-flex flex-column align-items-center">
      <img
        class="mb-3"
        [height]="130"
        [width]="130"
        alt="magnifier"
        src="assets/images/magnifying-glass.webp"
      />
      <h3 class="bold mb-2">{{ cardTitle }}</h3>
      <p>{{ cardSubtitle }}</p>
    </div>
    <need-help-card [salesAgent]="lead.salesAgent" />
  </div>
</div>
